import { useState, useEffect, useCallback } from 'react';

// API endpoint - HTTPS API (no proxy needed)
const API_URL = "https://api.hytale-id.net/api/status";

export function useServerStatus() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStatus = useCallback(async () => {
    console.log("[ServerStatus] Fetching from:", API_URL);
    
    try {
      const res = await fetch(API_URL, {
        method: "GET",
        cache: "no-store",
      });
      
      console.log("[ServerStatus] Response status:", res.status);

      if (!res.ok) {
        throw new Error("HTTP error: " + res.status);
      }

      const data = await res.json();
      console.log("[ServerStatus] JSON data:", data);

      // ONLINE if data.online === true, OFFLINE otherwise
      const isOnline = data.online === true;
      
      setStatus({
        online: isOnline,
        playerCount: data.playerCount ?? 0,
        maxPlayers: data.maxPlayers ?? 100,
        timestamp: data.timestamp ?? Date.now(),
      });
      setError(null);
      setLoading(false);
      
      console.log("[ServerStatus] Status set - Online:", isOnline);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : String(err);
      console.error("[ServerStatus] Fetch error:", errorMessage, err);
      
      setError(errorMessage);
      setStatus({
        online: false,
        playerCount: 0,
        maxPlayers: 100,
        timestamp: Date.now(),
      });
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Initial fetch
    fetchStatus();

    // Set up 30-second refresh interval
    const interval = setInterval(fetchStatus, 30000);

    return () => clearInterval(interval);
  }, [fetchStatus]);

  return { status, loading, error, refetch: fetchStatus };
}
